module.exports = __webpack_public_path__ + "media/images/logo-2ba5eb2279fbf19bd0db829d6bc34783.png";